import { render, staticRenderFns } from "./DashboardPortfolio.vue?vue&type=template&id=68cbf7ed&scoped=true&"
import script from "./DashboardPortfolio.vue?vue&type=script&lang=js&"
export * from "./DashboardPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPortfolio.vue?vue&type=style&index=0&id=68cbf7ed&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cbf7ed",
  null
  
)

export default component.exports